import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ComponentTabs} from "../../models/component-tabs";
import {IIconItem} from "../../models/sytles/icon-item";

@Injectable()
export default class StyleService {
  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getIcons(): Observable<IIconItem[]> {
    return this.http.get(this.baseUrl + "styles/icons") as Observable<IIconItem[]>;
  }
}
